import * as React from "react";
import {cx} from "emotion";
import {Link} from "react-router-dom";

import "./user-created-admin-layout.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";
import {UseState}       from "@Common/react/use-state";
import {AlertModal}     from "@Common/ui-components/heavy/common/design2/dialogs/alert-modal/alert-modal";
import {Responsive}     from "@Common/ui-components/responsive";
import {SliderCheckbox} from "@Common/ui-components/slider-checkbox/slider-checkbox";
import {SubHeader}      from "@Xpresso/routes/common/sub-header/sub-header";
import {Layout}         from "@Xpresso/routes/layout/layout";

import {rTilesViewConfig}       from "../../common/view-config/tiles-view-config";
import {UserCreatedFolderModal} from "../../user-created-folder-modal/user-created-folder-modal";

export const UserCreatedAdminLayout = ({activeTab, folders, showInactive, templateUploadModal, updatingFolderSequence, viewMode, next}) => cs(
    consumeContext("apis"),
    consumeContext("routerHistory"),
    ["alertModal", ({}, next) => AlertModal({next})],
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            md: 1024,
            lg: 1920,
        },
        next,
    }}/>],
    ["folderModal",({}, next) => UserCreatedFolderModal({
        activeTab,
        folderId: 0,
        index: 0,
        folders,
        next,
    })],
    ["disable", (_, next) => UseState({next})],
    ({alertModal, apis, disable, folderModal, responsive, routerHistory}) => {
        if(window.location.hash.startsWith("#new-template") && !templateUploadModal.showing) {
            templateUploadModal.show();
        }
        return (
        <Layout className="user-created-admin-5c8" active="catSubcatStyle">
            <SubHeader
                backLink={
                    <a
                        onClick={() => routerHistory.goBack()}
                        className="back"
                        xd-qa-type="link"
                        xd-qa-name="Back"
                    >
                        <i className="fa fa-chevron-left"/> Back
                    </a>
                }
                title="Manage Templates"
            />
            <div className="restrict-content-width">
                <div className="content">
                    <div className="headline">
                        <div className="tabs">
                            {items.map((item) => cs(
                                keyed(item.name),
                                () => (
                                    <Link
                                        className={cx("item", {active: activeTab === item.name})}
                                        to={item.link}
                                        xd-qa-name={item.linkLabel}
                                        xd-qa-type="link"
                                    >
                                        {item.linkLabel}
                                    </Link>
                                ),
                            ))}
                        </div>
                        <div className="right">
                            {(activeTab != "archive" && !folders.loading) && <div className={cx("save-folder-sequence", {disabled: disable.value})}>
                                {updatingFolderSequence.value ? <a xd-qa-type="link" xd-qa-name="Save Folder Sequence"
                                    onClick={async () => {
                                        if(disable.value) {
                                            return;
                                        }
                                        disable.onChange(true);
                                        let folderElements = document.getElementsByClassName("folder-tiles-ld3");
                                        let sequenceArray = [];
                                        for( const element of folderElements ) {
                                            let folderIdPrimary = parseInt( element.getAttribute('id') );
                                            if( folderIdPrimary ) {
                                                sequenceArray.push(folderIdPrimary);
                                            }
                                        }
                                        let result = await apis.next.userCreated.updateFolderSequence(sequenceArray);
                                        if( result?.errors || result?.errorMessage ) {
                                            await alertModal.show({message: "Error saving sequence."});
                                            disable.onChange(false);
                                            return;
                                        }
                                        disable.onChange(false);
                                        updatingFolderSequence.onChange(false);
                                    }}
                                >
                                    Save Folder Sequence
                                </a> : <a xd-qa-type="link" xd-qa-name="Save Folder Sequence"
                                    onClick={() => {
                                        updatingFolderSequence.onChange(true);
                                    }}
                                >
                                    Update Folder Sequence
                                </a>}
                            </div>}
                            <div className="show-inactive">
                                <div className="label">Show Inactive Templates</div>
                                {SliderCheckbox({
                                    value: showInactive.value,
                                    onChange: ()=>showInactive.onChange(!showInactive.value),
                                    xdQaName: "Active",
                                })}
                            </div>
                            {responsive.ge("md") && (
                                <>
                                    {rTilesViewConfig(viewMode)}
                                </>
                            )}
                        </div>
                    </div>
                    {next()}
                    <div className="buttons new-item">
                        {activeTab !== 'archive' ? <button aria-label="Create New Folder" className="createNewFolder"
                            xd-qa-type="button" xd-qa-name="Create New Folder"
                            onClick={() => folderModal.show()}>New Folder</button> : ""}
                        <button aria-label="Create New Template" className="createNewTemplate"
                            xd-qa-type="button" xd-qa-name="Create New Template" onClick={() => {
                                window.location.hash = "#new-template"; templateUploadModal.show()}
                        }>New Template</button>
                    </div>
                </div>
            </div>
        </Layout>
    )}
);

const items = [
    {
        linkLabel: "Private",
        name: "private",
        link: "/manage-templates/private",
    },
    {
        linkLabel: "Public",
        name: "public",
        link: "/manage-templates/public",
    },
    {
        linkLabel: "Archive",
        name: "archive",
        link: "/manage-templates/archive",
    },
];